import * as fromDatatype from '../datatype-library/index';

export interface app_tenant_deletion_cleanup_history_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  event_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  history_json: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
}

export class app_tenant_deletion_cleanup_history_hdr_RowClass
  implements app_tenant_deletion_cleanup_history_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    event_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tenant_code: fromDatatype.VarcharDatatypeInterface;
    action: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    history_json: fromDatatype.JsonDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
    date_completed: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
}